import ApiService from '../ApiService'

const reportService = {
    ordersfarmadomicilios() {
        return ApiService.get('/report-audit-add/ordersfarmadomicilios')
    },
    authorizations() {
        return ApiService.get('/report-audit-add/authorizations')
    },
    dispatchOrders() {
        return ApiService.get('/report-audit-add/dispatchOrders')
    },
    LogStatusChangeOrders() {
        return ApiService.get('/report-audit-add/LogStatusChangeOrders')
    },
    Auth_user(type, id, status) {
        const headers = { 'nit': '900277244', 'password': 'XkzJ4miaOaqx' };
        return ApiService.customRequest({
            url: `${process.env.VUE_APP_ROOT_API}/orders/authorizations-user?identificationType=${type}&identification=${id}&status=${status}`,
            method: "get",
            headers,
        });
    }
}

export default reportService